import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import themes from '../../js/stores/theme.js';
import languages from '../../js/stores/language.js';
import user from '../../js/stores/user.js';
import car from '../../js/stores/car.js';
import carFeatureLibrary from '../../js/controllers/car-feature-lib.js';
function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
    $ = _ref.$,
    $onMounted = _ref.$onMounted,
    $update = _ref.$update;
  var locale = languages.getters.Item.value;
  var isLogged = user.getters.isLogged.value;
  var isAdmin = false;
  var isCustomer = false;
  var userRoles = user.getters.roles.value;
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return themes.dispatch('checkTheme', '.panel-left');
        case 1:
          if (isLogged) {
            isAdmin = userRoles.includes(1); //Admin,
            isCustomer = userRoles.includes(4); //Customer,
            $update();
          }
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  var goUserEdit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var carItem, result, carId, obj, _t;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            carItem = {};
            _context2.prev = 1;
            _context2.next = 2;
            return car.dispatch('getCarData', user.getters.carId.value);
          case 2:
            result = _context2.sent;
            if (!(result.status !== undefined && result.status !== 200)) {
              _context2.next = 3;
              break;
            }
            $f7.toast.show({
              text: result.data.messages.error
            });
            return _context2.abrupt("return");
          case 3:
            carItem.CarMainData = result;
            carId = carItem.CarMainData.CarId;
            _context2.next = 4;
            return carFeatureLibrary.getLocalizedData(carId, 1);
          case 4:
            carItem.CarFeatureList = _context2.sent;
            _context2.next = 5;
            return carFeatureLibrary.getLocalizedData(carId, 2);
          case 5:
            carItem.CarUseRestrictionList = _context2.sent;
            _context2.next = 6;
            return carFeatureLibrary.getLocalizedData(carId, 3);
          case 6:
            carItem.CarPenaltyUseList = _context2.sent;
            obj = {
              props: carItem
            };
            obj.props.isTab = true;
            obj.props.tabId = 'tab-4';
            $f7.views.main.router.navigate('/user-edit/', obj);
            _context2.next = 8;
            break;
          case 7:
            _context2.prev = 7;
            _t = _context2["catch"](1);
            console.error(_t);
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 7]]);
    }));
    return function goUserEdit() {
      return _ref3.apply(this, arguments);
    };
  }();
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<!-- Left panel with cover effect-->
<div class="panel panel-left panel-reveal dark">
  <div class="view">
    <div class="page">
      <div class="navbar">
        <div class="navbar-inner">
          <div class="title">Menu</div>
        </div>
      </div>
      <div class="page-content">
        <div class="list">
          <ul>
            ${!isLogged && $h`
            <li>
              <a class="item-link item-content panel-close" href="/user-new/">
                <div class="item-media"><i class="icon material-symbols-outlined color-blue">person_add</i></div>
                <div class="item-inner">
                  <div class="item-title">${locale.translate('home.panelLeft.userNewAccountLabel')}</div>
                </div>
              </a>
            </li>
            <li>
              <a class="item-link item-content panel-close" href="/user-password-recovery/">
                <div class="item-media"><i class="icon material-symbols-outlined color-green">lock_reset</i></div>
                <div class="item-inner">
                  <div class="item-title">${locale.translate('user.reset.requestNewPassword')}</div>
                </div>
              </a>
            </li>
            `}
            ${isLogged && $h`
            <li>
              <a class="item-link item-content panel-close" @click="${goUserEdit}">
                <div class="item-media"><i class="icon material-symbols-outlined color-red">user_attributes</i></div>
                <div class="item-inner">
                  <div class="item-title">${locale.translate('home.panelLeft.userEditAccountLabel')}</div>
                </div>
              </a>
            </li>
            <li>
              <a class="item-link item-content panel-close" href="/loan-dashboard/">
                <div class="item-media"><i class="icon material-symbols-outlined color-green">list</i></div>
                <div class="item-inner">
                  <div class="item-title">${locale.translate('loan.lends')}</div>
                </div>
              </a>
            </li>
            ${isAdmin ? $h`
            <li>
              <a class="item-link item-content panel-close" href="/admin-panel/">
                <div class="item-media"><i class="icon material-symbols-outlined color-blue">admin_panel_settings</i></div>
                <div class="item-inner">
                  <div class="item-title">${locale.translate('admin.title')}</div>
                </div>
              </a>
            </li>
            `: $h`
            <li></li>
            `}
            `}
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
`
    }
    ;
}
framework7Component.id = 'cd91ab34c7';
export default framework7Component;